
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAlarmPob as ObiAlarmPobElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-alarm-pob.js';
 
 
 

 
 export const ObiAlarmPob = createComponent({
   react: React,
   tagName: 'obi-alarm-pob',
   elementClass: ObiAlarmPobElement,
   events: {
     
   }
  });
 
 